import React from 'react';
import { VictimsPageProvider } from '../../components/VictimsPageProvider';

export const CiviliansPage: React.FC = () => {
  return (
    <VictimsPageProvider isMilitary={false} />
  );
};
